import prettyBytes from 'pretty-bytes';

const SizeCell = ({ value: size }) => prettyBytes(size);

export default SizeCell;
